import { Box, Typography } from "@mui/material";
import React from "react";

const BoxNumberUser = ({ data }) => {
  return (
    <Box direction="horizontal" gap={2}>
      <Typography sx={{ textAlign: "end" }} variant="h3">
        <b>{data.total}</b>
      </Typography>
    </Box>
  );
};

export default BoxNumberUser;
